// Solufy Number Count-Up Animation & Dynamic Chart Bar Triggers

function parseNumberWithAffixes(text) {
	const raw = text.trim();
	const match = raw.match(/^([^\d]*)([\d,]+(?:\.\d+)?)([^\d]*)$/);
	if (!match) return null;

	const prefix = match[1] || "";
	const numStr = match[2].replace(/,/g, "");
	const suffix = match[3] || "";
	const targetNum = parseFloat(numStr);
	if (isNaN(targetNum)) return null;

	const hasDecimals = numStr.includes(".");
	const decimalPlaces = hasDecimals ? numStr.split(".")[1].length : 0;

	return { prefix, targetNum, suffix, decimalPlaces, original: raw };
}

function animateValue(el, parsed, duration = 1400) {
	const { prefix, targetNum, suffix, decimalPlaces } = parsed;
	const startTime = performance.now();

	const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

	function update(currentTime) {
		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const easedProgress = easeOutCubic(progress);
		const currentVal = targetNum * easedProgress;

		let formatted;
		if (decimalPlaces > 0) {
			formatted = currentVal.toFixed(decimalPlaces);
		} else {
			formatted = Math.round(currentVal).toLocaleString();
		}

		el.textContent = `${prefix}${formatted}${suffix}`;

		if (progress < 1) {
			requestAnimationFrame(update);
		} else {
			el.textContent = parsed.original;
		}
	}

	requestAnimationFrame(update);
}

export function mountCounters(root = document) {
	if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		return () => {};
	}

	const selectorList = [
		"[data-counter]",
		".solufy-cred-pill b",
		".operations-ui__grid strong",
		".solufy-ui-fallback strong",
		".solufy-metrics strong",
		".solufy-chart-metric strong",
		".solufy-stat-card strong",
		".solufy-bar-val",
		".solufy-pie-center__val",
		".legend-val",
	].join(", ");

	const elements = root.querySelectorAll(selectorList);
	if (
		!elements.length &&
		!root.querySelectorAll(".operations-chart, .solufy-bar-chart, .solufy-line-chart, .solufy-pie-chart").length
	) {
		return () => {};
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				const target = entry.target;

				if (target.dataset.counted === "true") return;
				target.dataset.counted = "true";

				// If it's a chart container, trigger animation class
				if (
					target.classList.contains("operations-chart") ||
					target.classList.contains("solufy-bar-chart") ||
					target.classList.contains("solufy-line-chart") ||
					target.classList.contains("solufy-pie-chart")
				) {
					target.classList.add("is-animated");
					obs.unobserve(target);
					return;
				}

				// Number animation
				const parsed = parseNumberWithAffixes(target.textContent);
				if (parsed && parsed.targetNum > 0) {
					animateValue(target, parsed);
				}

				obs.unobserve(target);
			});
		},
		{
			threshold: 0.15,
			rootMargin: "0px 0px -40px 0px",
		},
	);

	elements.forEach((el) => observer.observe(el));

	// Observe charts
	root.querySelectorAll(".operations-chart, .solufy-bar-chart, .solufy-line-chart, .solufy-pie-chart").forEach((chart) => {
		observer.observe(chart);
	});

	return () => observer.disconnect();
}
